<div class="category-form">
    <form [formGroup]="form" class="form-content">
        <!-- Name section -->
        <div class="section-title">{{ 'permit.config.categories.form_section_name' | translate }}</div>

        <div class="bilingual-row">
            <app-form-input-v2
                [label]="'permit.config.common.name_fr' | translate"
                placeholder=""
                formControlName="nameFr"
            >
                <app-form-error *ngIf="form.get('nameFr').touched && form.get('nameFr').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-input-v2>

            <app-form-input-v2
                [label]="'permit.config.common.name_en' | translate"
                placeholder=""
                formControlName="nameEn"
            >
                <app-form-error *ngIf="form.get('nameEn').touched && form.get('nameEn').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-input-v2>
        </div>

        <!-- Icon section -->
        <div class="section-title">{{ 'permit.config.categories.icon' | translate }}</div>

        <div class="icon-form">
            <app-bciti-icon-select
                formControlName="icon"
                [icons]="iconOptions"
                [validation]="false"
            ></app-bciti-icon-select>
        </div>

        <!-- Active toggle -->
        <div class="active-row">
            <app-form-toggle formControlName="active">
                {{ 'permit.config.common.active' | translate }}
            </app-form-toggle>
        </div>

        <!-- Save / Cancel -->
        <div class="form-actions">
            <button type="button" mat-button class="cancel-button" (click)="onCancel()">
                {{ 'permit.config.common.cancel' | translate }}
            </button>
            <button
                type="button"
                mat-flat-button
                class="save-button"
                [disabled]="form.invalid || isSaving"
                (click)="onSave()"
            >
                {{ 'permit.config.common.save' | translate }}
            </button>
        </div>
    </form>
</div>
